import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9003Component } from './kymw9003.component';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetAuthoritySetListService } from './api-services/get-authority-set-list.service';
import { KYMW9004Module } from '../kymw9004/kymw9004.module';

/**
 * 権限一覧画面 モジュール設定クラス
 *
 * @export KYMW9003Module
 * @class KYMW9003Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    KYMW9004Module,
  ],
  declarations: [
    KYMW9003Component,
  ],
  providers: [
    GetAuthoritySetListService,
  ],
})

export class KYMW9003Module {

}